/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

// Asset Imports
import chevGreenEast from '../../assets/svgs/chevron-pattern-green-east.svg'
import chevGreenNorth from '../../assets/svgs/chevron-pattern-green-north.svg'
import chevGreenSouth from '../../assets/svgs/chevron-pattern-green-south.svg'
import chevGreenWest from '../../assets/svgs/chevron-pattern-green-west.svg'

const ChevronBackgroundStroke = ({ children, className, direction }) => (
  <div className={className}>
    <div className={`chev-pattern-outline-green ${direction}`} />
    <div className="position-relative">
      {children}
    </div>
  </div>
)

ChevronBackgroundStroke.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['north', 'south', 'east', 'west']).isRequired,
}

ChevronBackgroundStroke.defaultProps = {
  className: '',
}

export default styled(ChevronBackgroundStroke)`
  position: relative;
  .chev-pattern-outline-green {
    background-image: ${(props) => (props.direction === 'east' ? `url(${chevGreenEast})` : props.direction === 'north' ? `url(${chevGreenNorth})` : props.direction === 'south' ? `url(${chevGreenSouth})` : props.direction === 'west' ? `url(${chevGreenWest})` : `url(${chevGreenNorth})`)};
    background-position: center;
    background-repeat: repeat;
    background-size: ${(props) => (props.direction === 'north' || props.direction === 'south' ? '162px 72px' : '72px 162px')};
    opacity: 0.15;
    position: absolute;
      top: 0; right: 0; bottom: 0; left: 0;
    width: 100%;
  }
`
